module.exports = __webpack_public_path__ + "img/truewallet.17159467.png";